import { signalStore, withState } from '@ngrx/signals';

import { avecMéthodesRessources } from './ressource.methods';
import { avecSélecteursRessources } from './ressource.selectors';
import { initialState } from './ressource.state';

export const RessourceStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  avecMéthodesRessources(),
  avecSélecteursRessources(),
);
